import config from './config.js';

export default {
    autoTfn () {
        (function (para) {
            var p = para.sdk_url, n = para.name, w = window, d = document, s = 'script', x = null, y = null;
            if (typeof (w['sensorsDataAnalytic201505']) !== 'undefined') {
                return false;
            }
            w['sensorsDataAnalytic201505'] = n;
            w[n] = w[n] || function (a) {
                return function () {
                    (w[n]._q = w[n]._q || []).push([a, arguments]);
                }
            };
            var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister', 'getAppStatus'];
            for (var i = 0; i < ifs.length; i++) {
                w[n][ifs[i]] = w[n].call(null, ifs[i]);
            }
            if (!w[n]._t) {
                x = d.createElement(s), y = d.getElementsByTagName(s)[0];
                x.async = 1;
                x.src = p;
                x.setAttribute('charset', 'UTF-8');
                w[n].para = para;
                y.parentNode.insertBefore(x, y);
            }
        })({
            sdk_url: 'https://cdn.jsdelivr.net/npm/sa-sdk-javascript@1.13.2/sensorsdata.min.js',
            heatmap: {
                //是否开启触达注意力图，默认 not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启
                //需要 Web JS SDK 版本号大于 1.9.1
                show_log: true,
                scroll_notice_map:'not_collect',
                clickmap:'not_collect'
            },
            use_client_time:true,
            name: 'sensors',
            server_url: config.config().VUE_APP_SERVER,
        });
    }
}
